import { Head, router } from '@inertiajs/react'
import { RefreshCw } from 'lucide-react'
import CommandCenterLayout from '@/frontend/layouts/CommandCenterLayout'
import ConnectionsCatalog from '@/frontend/features/IntegrationAccess/ConnectionsCatalog'
import type { OauthOptions } from '@/frontend/features/IntegrationAccess/CreateConnectionDialog'
import type { AccessSnapshot } from '@/frontend/features/IntegrationAccess/types'
import { Button } from '@/components/ui/button'

interface Props { snapshot: AccessSnapshot; oauth_options: OauthOptions }

function CustomerOauthPage({ snapshot, oauth_options }: Props) {
  const copy = snapshot.admin_copy
  return <>
    <Head title={String(copy.title)} />
    <div key={snapshot.organization_filter} className="mx-auto max-w-6xl space-y-6 pb-12">
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div><h1 className="text-2xl font-semibold tracking-tight">{String(copy.title)}</h1><p className="mt-2 max-w-2xl text-sm text-muted-foreground">{String(copy.description)}</p></div>
        <div className="flex items-end gap-2"><label className="min-w-48 text-xs text-muted-foreground">{String(copy.organization_filter)}
          <select className="mt-2 block h-9 w-full rounded-md border border-input bg-background px-3 text-sm text-foreground" value={snapshot.organization_filter} onChange={(event) => router.get('/cc/external_oauth_connections', event.target.value === 'all' ? {} : { organization_id: event.target.value })}>
            <option value="all">{String(copy.all_organizations)}</option><option value="unassigned">{String(copy.unassigned_organizations)}</option>
            {snapshot.organizations.map((organization) => <option key={organization.id} value={organization.id}>{organization.name}</option>)}
          </select></label><Button variant="outline" size="icon" aria-label={snapshot.copy.refresh} onClick={() => router.reload({ only: ['snapshot', 'oauth_options'] })}><RefreshCw className="size-4" strokeWidth={1.75} /></Button></div>
      </header>
      <ConnectionsCatalog snapshot={snapshot} options={oauth_options} />
    </div>
  </>
}

CustomerOauthPage.layout = (page: React.ReactElement) => <CommandCenterLayout>{page}</CommandCenterLayout>
export default CustomerOauthPage
